import React, { useRef, useState } from "react";
import {
  I2cInput,
  I2cCheckboxGroup,
  I2cListItem,
  I2cCheckbox,
} from "@webcomponents/i2cwebcomponents/dist/react";
import "../../PrepaidComponents/Prepaid.scss";
import { Controller } from "react-hook-form";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import { dataMigInfo, credit_dataMigAttr } from "./FieldsListingLabels";
const DataMigeration = ({ control, handleValueChanges, methods, errors }) => {
  const checkboxRef = useRef(null);
  const [selectedCreditMigAttr, setCreditMigAttr] = useState([]);
  const handleDataMigInfoChange = (value) => {
    let updatedData = methods.getValues("pi_key_component_custodians");
    if (updatedData.includes(value)) {
      updatedData = updatedData.filter((card) => card !== value);
    } else {
      updatedData.push(value);
    }
    if (!updatedData.includes(3)) {
      methods.setValue("pi_key_component_custodians_other", "");
    }
    methods.setValue("pi_key_component_custodians", updatedData);
    methods.trigger();
    handleValueChanges();
  };

  const handleDataMigrationAttributeChange = (value) => {
    let updatedData = methods.getValues("pi_data_migration_attributes");
    if (updatedData.includes(value)) {
      updatedData = updatedData.filter((card) => card !== value);
    } else {
      updatedData.push(value);
    }

    if (!updatedData.includes(16)) {
      methods.setValue("pi_data_migration_attributes_other", "");
    }
    methods.setValue("pi_data_migration_attributes", updatedData);
    methods.trigger();
    handleValueChanges();
  };

  return (
    <div className="forms-instance">
      <div i2c-grid="grid gap-sm" className="section-space">
        <div i2c-grid="12">
          <div className="sub-heading">
            Data Migration Information<sup>•</sup>
          </div>
          <div className="custom-label-light">
            Applicable only for migrations.
            <span className="custom-label">
              For data migration clients MUST submit the Security Keys.
            </span>
          </div>
        </div>
        <div i2c-grid="12">
          <div className="single-field-wrapper halfWidth">
            <Controller
              name="pi_current_processor_name"
              control={control}
              render={({ field }) => (
                <I2cInput
                  {...field}
                  label="Current Processor Name"
                  className="single-input-field"
                  onI2cInput={(e) => {
                    const value = e.target.value;
                    field.onChange(value);
                    handleValueChanges();
                  }}
                  required
                  size="large"
                  name={"pi_current_processor_name"}
                />
              )}
            />
            {/* <ErrorMessage
              show={
                errors.pi_current_processor_name &&
                  methods.formState.touchedFields.pi_current_processor_name
                  ? true
                  : false
              }
              message={
                errors.pi_current_processor_name?.message ?? "Invalid input"
              }
            /> */}
          </div>
        </div>
      </div>
      <div i2c-grid="grid gap-sm" className="section-space">
        <div i2c-grid="12">
          <Controller
            name="pi_key_component_custodians"
            control={control}
            render={({ field }) => (
              <I2cCheckboxGroup
                {...field}
                label="Existing Clear Key Components Custodian"
              >
                <div i2c-grid="grid gap-sm">
                  {dataMigInfo.map((card, index) => (
                    <I2cListItem
                      key={index}
                      i2c-grid="6@md"
                      variant="receipt"
                      label={card.label}
                      sublabel=""
                      value=""
                      type="checkbox"
                      checked={methods
                        .watch("pi_key_component_custodians")
                        .includes(card.value)}
                      onI2cCheckboxClicked={() =>
                        handleDataMigInfoChange(card.value)
                      }
                    >
                      <I2cCheckbox
                        slot="prefix"
                        name="pi_dataMigrationInfo"
                        value={card.value}
                        label=""
                        ignoreTab
                        filled
                        checked={methods
                          .watch("pi_key_component_custodians")
                          .includes(card.value)}
                    
                      ></I2cCheckbox>
                    </I2cListItem>
                  ))}
                </div>
              </I2cCheckboxGroup>
            )}
          />
          {methods.watch("pi_key_component_custodians").includes(3) && (
            <div key={"pi_key_component_custodians_other"} i2c-grid="grid 6@md">
              <div className="single-field-wrapper mt-16">
                <Controller
                  name="pi_key_component_custodians_other"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      label="Enter Details"
                      className="single-input-field"
                      onI2cInput={(e) => {
                        const value = e.target.value;
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      required
                      placeholder="Other details"
                      size="large"
                      name={"pi_key_component_custodians_other"}
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.pi_key_component_custodians_other &&
                      methods.formState.touchedFields
                        .pi_key_component_custodians_other
                      ? true
                      : false
                  }
                  message={
                    errors.pi_key_component_custodians_other?.message ??
                    "Invalid input"
                  }
                /> */}
              </div>
            </div>
          )}
        </div>
      </div>
      <div i2c-grid="grid gap-sm" className="section-space">
        <div i2c-grid="12">
          <div className="sub-heading">Data Migration Attributes</div>
          <I2cCheckboxGroup
            label="Applicable only for migrations. Please select existing data to be migrated."
            ref={checkboxRef}
          >
            <div i2c-grid="grid gap-sm">
              {credit_dataMigAttr.map((dma, index) => (
                <I2cListItem
                  key={index}
                  i2c-grid="4@md"
                  variant="receipt"
                  label={dma.label}
                  sublabel=""
                  value=""
                  type="checkbox"
                  checked={methods
                    .watch("pi_data_migration_attributes")
                    .includes(dma.value)}
                  onI2cCheckboxClicked={() =>
                    handleDataMigrationAttributeChange(dma.value)
                  }
                >
                  <I2cCheckbox
                    slot="prefix"
                    name=""
                    value={dma.label}
                 
                    filled
                    label=""
                    style={{ marginTop: "var(--i2c-spacing-0-5)" }}
                    checked={methods
                      .watch("pi_data_migration_attributes")
                      .includes(dma.value)}
                     
                  />
                </I2cListItem>
              ))}
            </div>
          </I2cCheckboxGroup>
          {methods.watch("pi_data_migration_attributes").includes(16) && (
            <div
              key={"pi_data_migration_attributes_other"}
              i2c-grid="grid 6@md"
            >
              <div className="single-field-wrapper mt-16">
                <Controller
                  name="pi_data_migration_attributes_other"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      label="Enter Details"
                      className="single-input-field"
                      onI2cInput={(e) => {
                        const value = e.target.value;
                        field.onChange(value);
                        methods.trigger();
                        handleValueChanges();
                      }}
                      required
                      placeholder="Other details"
                      size="large"
                      name={"pi_data_migration_attributes_other"}
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.pi_data_migration_attributes_other &&
                      methods.formState.touchedFields
                        .pi_data_migration_attributes_other
                      ? true
                      : false
                  }
                  message={
                    errors.pi_data_migration_attributes_other?.message ??
                    "Invalid input"
                  }
                /> */}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DataMigeration;
